import { render } from "./_list.vue?vue&type=template&id=40a0f6aa&lang=pug"
import script from "./_list.vue?vue&type=script&setup=true&lang=js"
export * from "./_list.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__